var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMereKapaciteta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "30px",
    width: "30px",
    id: "XMLID_261_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar-chart"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,23H0v-2h24V23z M23,19h-6V1h6V19z M19,17h2V3h-2V17z M15,19H9V9h6V19z M11,17h2v-6h-2V17z M7,19H1V5h6V19z M3,17h2V7 H3V17z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMereKapaciteta);
export default __webpack_public_path__ + "static/media/MereKapaciteta.f13ca965988331b49d75f98317757e77.svg";
export { ForwardRef as ReactComponent };